import { fetchAndActivate, getValue } from "firebase/remote-config";
import {remoteConfig} from "@dropDesk/data/clients/firebase.client";

export const firebaseRemoteConfigDefaultsValue = {
  'ft_onesignal_mode': 'off',
}

export class FeatureToggle {
  static chatMessagesV2Enabled = true; // depois: getValue(remoteConfig, 'ft_chat_messages_v2')

  static async initialize(): Promise<void> {
    await fetchAndActivate(remoteConfig);
  }

  static getOneSignalToggleState(): string {
    const val = getValue(remoteConfig, 'ft_onesignal_mode');
    return val.asString();
  }

  static isChatMessagesV2Enabled(): boolean {
    return FeatureToggle.chatMessagesV2Enabled;
  }
}